export enum FCPaymentOptions {
  PatientRequestedCallIfNeeded = -1,
  PatientRequestedCall = -2,
  CallPatient = -3,
}
